export default "__VITE_ASSET__Cvi1qDhL__"